import React from 'react'
import { useTranslation } from 'react-i18next'

import './cta26.css'
import { Link } from 'react-router-dom'

const CTA26 = () => {
  const { t } = useTranslation()
  return (
    <div className="thq-section-padding">
      <div className="thq-section-max-width">
        <div className="cta26-accent2-bg">
          <div className="cta26-accent1-bg">
            <div className="cta26-container2">
              <div className="cta26-content">
                <span className="thq-heading-2">{t('cta26.heading')}</span>
                <p className="thq-body-large">
                  {t('cta26.content')}
                </p>
              </div>
              <div className="cta26-actions">
                <Link to="/booking">
                  <button type="button" className="thq-button-filled cta26-button">
                    <span>{t('common.bookNow')}</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CTA26
